module.exports = __webpack_public_path__ + "static/media/icn_policy_found_f.80d3b981.svg";